import React from "react";
import { BUSINESS } from "../../lib/config";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <Logo size={42} withText theme="dark" />
          <p className="text-sm mt-4 max-w-xs">
            Certified backflow testing, installation, repair and City of Laredo filing for homes and
            businesses.
          </p>
        </div>
        <div>
          <div className="overline !text-slate-400">Contact</div>
          <div className="mt-3 space-y-2 text-sm">
            <a href={BUSINESS.phoneHref} className="block hover:text-white">{BUSINESS.phone}</a>
            <a href={BUSINESS.emailHref} className="block hover:text-white break-all">{BUSINESS.email}</a>
          </div>
        </div>
        <div>
          <div className="overline !text-slate-400">Service Area</div>
          <div className="mt-3 text-sm leading-relaxed">
            {BUSINESS.areas.join(" · ")}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Laredo Backflow LLC. All rights reserved.</div>
          <div>Licensed · Insured · City of Laredo Certified</div>
        </div>
      </div>
    </footer>
  );
}
